import {createDispatchActions, selectTheme} from '../../store'
import {ButtonColorTheme, Checkbox, PopupSize, PopupTemplate} from '..'
import {useEffect, useState} from 'react'
import {RequestResult} from '../../lib'

export interface RevertToLegacyProjectPopupProps {
  projectId: string
  onClose: () => void
  onFinish: () => void
}

export const RevertToLegacyProjectPopup = (props: RevertToLegacyProjectPopupProps) => {
  const {projectId, onClose, onFinish} = props

  const {color, fontSize, fontWeight} = selectTheme()

  const {doREQUEST_PROJECT_SCHEDULE_CONFIG_DELETE} = createDispatchActions()

  const [allRequiredCheckFilled, setAllRequiredCheckFilled] = useState(false)

  const [requestResult, setRequestResult] = useState<RequestResult | null>(null)

  useEffect(() => {
    if (requestResult?.success) {
      onFinish()
    }
  }, [requestResult])

  const handleAction = () => {
    doREQUEST_PROJECT_SCHEDULE_CONFIG_DELETE({
      setRequestResult,
      payload: {projectId},
    })
  }

  const contentTextStyle: React.CSSProperties = {
    fontSize: fontSize.h6,
    fontWeight: fontWeight.bold,
    color: color.textIcon.secondary,
  }

  return (
    <PopupTemplate
      {...{
        title: 'Switch to legacy project',
        description: (
          <p
            css={{
              ...contentTextStyle,
            }}>
            This project type was used before June 2025. It doesn’t support event trackers or real schedules. Tasks are
            always persistent, with schedules written into each task.
          </p>
        ),
        background: true,
        popupSize: PopupSize.Small,
        handleClosePopup: () => onClose(),
        mainFunction: () => handleAction(),
        buttonContent: 'Switch to Legacy Project',
        buttonColorTheme: ButtonColorTheme.Warning,
        buttonDisabled: !allRequiredCheckFilled,
      }}>
      <div
        css={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '8px',
        }}>
        <Checkbox value={allRequiredCheckFilled} onChange={(value: boolean) => setAllRequiredCheckFilled(value)} />
        <p
          css={{
            ...contentTextStyle,
          }}>
          I understand this change is permanent. To use scheduled projects, I’ll need to create a new project.
        </p>
      </div>
    </PopupTemplate>
  )
}
